<template>
    <div class="slice-testimonials--single-quote__author-info">
        <div class="slice-testimonials--single-quote__author">
            <div v-if="isFilled.keyText(author)" data-testid="testimonials-single-quote-author">{{ author }}</div>
            <div v-if="isFilled.keyText(authorJob)" data-testid="testimonials-single-quote-author-job">{{ authorJob }}</div>
        </div>
        <div v-if="isFilled.image(logo)" class="slice-testimonials--single-quote__separator" aria-hidden="true" />
        <PrismicImage
            v-if="isFilled.image(logo)"
            :field="logo"
            :alt="logo.alt || ''"
            class="slice-testimonials--single-quote__logo"
            data-testid="testimonials-single-quote-logo"
            width="120"
        />
    </div>
</template>

<script setup lang="ts">
    import {isFilled} from '@prismicio/helpers';
    import type {ImageField, KeyTextField} from '@prismicio/types';
    import {PrismicImage} from '@prismicio/vue';

    defineProps<{
        author: KeyTextField;
        authorJob: KeyTextField;
        logo: ImageField;
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .slice-testimonials--single-quote {
        &__author-info {
            display: flex;
            flex-direction: column;
            gap: var(--joy-core-spacing-4);

            @include mq.screen_md(min) {
                flex-direction: row;
                align-items: center;
            }
        }

        &__author {
            line-height: var(--joy-line-height-large);

            :first-child {
                color: var(--joy-color-neutral-70);

                @include text.getFontBySize(primary-400);

                font-weight: var(--joy-font-weight-bold);
            }

            :last-child {
                color: var(--joy-color-text-default);

                @include text.getFontBySize(primary-300);
            }
        }

        &__separator {
            display: none;

            @include mq.screen_md(min) {
                display: block;
                align-self: stretch;
                width: 1px;
                background-color: var(--joy-color-neutral-70);
            }
        }

        &__logo {
            width: 120px;
            max-height: 35px;
            object-fit: contain;
        }
    }
</style>
